import { render, staticRenderFns } from "./DatacenterNew.vue?vue&type=template&id=27887829&scoped=true"
import script from "./DatacenterNew.vue?vue&type=script&lang=js"
export * from "./DatacenterNew.vue?vue&type=script&lang=js"
import style0 from "./DatacenterNew.vue?vue&type=style&index=0&id=27887829&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27887829",
  null
  
)

export default component.exports